__turbopack_context__.v({
  "cardImage": "WhyTemokSection-module__VIB78W__cardImage",
  "cardWrapper": "WhyTemokSection-module__VIB78W__cardWrapper",
  "ctaBtn": "WhyTemokSection-module__VIB78W__ctaBtn",
  "header": "WhyTemokSection-module__VIB78W__header",
  "icon": "WhyTemokSection-module__VIB78W__icon",
  "infoBox": "WhyTemokSection-module__VIB78W__infoBox",
  "infoBtn": "WhyTemokSection-module__VIB78W__infoBtn",
  "infoHeading": "WhyTemokSection-module__VIB78W__infoHeading",
  "leftBlock": "WhyTemokSection-module__VIB78W__leftBlock",
  "leftCol": "WhyTemokSection-module__VIB78W__leftCol",
  "list": "WhyTemokSection-module__VIB78W__list",
  "para": "WhyTemokSection-module__VIB78W__para",
  "rightCol": "WhyTemokSection-module__VIB78W__rightCol",
  "section": "WhyTemokSection-module__VIB78W__section",
  "starIconBox": "WhyTemokSection-module__VIB78W__starIconBox",
  "title": "WhyTemokSection-module__VIB78W__title",
  "titleWhy": "WhyTemokSection-module__VIB78W__titleWhy",
});
